var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountMenu1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_408_15",
    "data-name": "Component 408 \\u2013 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65.317,
    height: 75.969,
    viewBox: "0 0 65.317 75.969",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4739",
    "data-name": "Rectangle 4739",
    width: 65.317,
    height: 75.969,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4523",
    "data-name": "Group 4523",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6033",
    "data-name": "Path 6033",
    d: "M23.45,75.815a17.2,17.2,0,0,0,.189-8.34,4.3,4.3,0,0,0-3.178-3.309,17.7,17.7,0,0,0-4.552-.522,43.927,43.927,0,0,1-4.74.119c-3.621-.334-5.847-2.774-4.313-6.57.8-1.828-.041-3-.624-4.039-1.717-3.079.8-3.773.842-5.919a1.848,1.848,0,0,0-1.71-1.819,5.5,5.5,0,0,1-3.305-1.49A2.006,2.006,0,0,1,1.8,41.475C8.123,31.183,6.839,33.892,9.03,19.4,10.463,9.914,21.012-1.342,42.126,2.15A31.073,31.073,0,0,1,54.684,6.713c8.6,5.875,13.229,18.256,8.727,32.657-2.529,8.093-8.169,16.773-6.44,25.789l2.454,10.078",
    transform: "translate(-0.673 -0.673)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6034",
    "data-name": "Path 6034",
    d: "M31.673,44.865l-.132,1.477a2.131,2.131,0,0,0,1.934,2.312l3.042.271a14.464,14.464,0,0,0,3.114,6.723L37.88,58.14a2.132,2.132,0,0,0,.519,2.97l2.76,1.939a2.132,2.132,0,0,0,2.97-.519l1.756-2.5a14.588,14.588,0,0,0,7.374.657l1.287,2.772a2.132,2.132,0,0,0,2.831,1.035l3.06-1.421a2.132,2.132,0,0,0,1.036-2.831L60.189,57.48a14.441,14.441,0,0,0,4.254-6.066l3.042.271A2.131,2.131,0,0,0,69.8,49.751l.131-1.477",
    transform: "translate(-14.149 -20.131)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6035",
    "data-name": "Path 6035",
    d: "M31.787,31.5l.132-1.477a2.131,2.131,0,0,1,2.312-1.934l3.042.271A14.459,14.459,0,0,1,41.527,22.3l-1.283-2.763A2.132,2.132,0,0,1,41.279,16.7l3.06-1.421a2.132,2.132,0,0,1,2.831,1.036l1.287,2.772a14.592,14.592,0,0,1,7.373.657l1.757-2.5a2.132,2.132,0,0,1,2.97-.518l2.76,1.939a2.132,2.132,0,0,1,.519,2.969l-1.752,2.492A14.443,14.443,0,0,1,65.2,30.85l3.042.271a2.131,2.131,0,0,1,1.934,2.312l-.132,1.477",
    transform: "translate(-14.263 -6.767)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6036",
    "data-name": "Path 6036",
    d: "M68.153,41.307a9.17,9.17,0,1,1-8.32-9.948A9.17,9.17,0,0,1,68.153,41.307Z",
    transform: "translate(-22.367 -14.054)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6037",
    "data-name": "Path 6037",
    d: "M68.589,39.424a5.823,5.823,0,0,0-3.976-2.078c-.179-.016-.355-.024-.531-.024a5.762,5.762,0,0,0-2.91.8,5.843,5.843,0,0,1-.018,10.13,5.816,5.816,0,0,0,2.417.775c.179.016.356.024.531.024A5.9,5.9,0,0,0,69.931,43.7a5.825,5.825,0,0,0-1.342-4.281",
    transform: "translate(-27.44 -16.746)",
    fill: "#ffbf00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountMenu1);
export default __webpack_public_path__ + "static/media/AccountMenu-1.a7131a026f05b5bdd896224e7a617ef1.svg";
export { ForwardRef as ReactComponent };